// extracted by mini-css-extract-plugin
export var body = "_cg-5";
export var closeButton = "_cg-f";
export var container = "_cg-1";
export var content = "_cg-2";
export var cta = "_cg-c";
export var ctaLabel = "_cg-b";
export var eyebrow = "_cg-3";
export var howTo = "_cg-6";
export var image = "_cg-e";
export var modal = "_cg-0";
export var socialButton = "_cg-d";
export var stepCard = "_cg-8";
export var stepLabel = "_cg-a";
export var stepNumber = "_cg-9";
export var steps = "_cg-7";
export var title = "_cg-4";